import BaseModel from "../../../core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";

export default class BulkAssignToSaleModel extends BaseModel {
  quantity = null
  stock_no = null
  title = null
  reservations = []
  available_quantity = null
  inventory_uuid = null
  reserve_quantity = 1
  reserve_number = 1

  customMessages = {
    "reserve_quantity": {
      max_value: function (name, rule) {
        return i18n.t('Reserve quantity cannot exceed {val}', {val: rule.max})
      }
    }
  }

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
    this.initTranslatableFields(this);
  }
}
